import React, { useMemo } from 'react';
import classNames from 'classnames';
import { CheckIcon } from '@fiverr-private/icons';
import { translate } from '@fiverr-private/i18n-react';
import { getCategoriesText } from '@fiverr-private/seller_pages_toolbox';
import { GigCategory } from '../../../../types/seller-phoenix';

import styles from './styles.module.scss';

const COPY_PREFIX = 'freelancer_page.pro_overview.pro_subcategories';

interface ProSubcategoriesProps {
    titleClassName?: string;
    proSubcategories: GigCategory[];
}

export const ProSubcategories: React.FC<ProSubcategoriesProps> = ({ proSubcategories = [], titleClassName }) => {
    const sortedSubcategoriesNames = useMemo(() => getCategoriesText(proSubcategories).sort(), [proSubcategories]);

    return (
        <>
            <p className={classNames('m-b-8', 'text-semi-bold', styles.title, titleClassName)}>
                {translate(`${COPY_PREFIX}.title`)}
            </p>
            <ul className={classNames('flex', styles.list)}>
                {sortedSubcategoriesNames.map((name) => (
                    <li className={classNames('flex', 'flex-items-baseline', styles.item)} key={`subcategory-${name}`}>
                        <span className={classNames('flex-center', 'm-r-8', styles.iconContainer)}>
                            <CheckIcon size={16} />
                        </span>
                        <p className={styles.subcategoryLabel}>{name}</p>
                    </li>
                ))}
            </ul>
        </>
    );
};
